'use client';

import { useEffect } from 'react';
import { initializeAd, calculateAdSize } from '@/lib/adsense';
import { AAMAreaProps } from '@/types/aam.d';

export function AAMArea({ width, height, className }: AAMAreaProps) {
  useEffect(() => {
    // 광고 단위 초기화
    initializeAd();
  }, [width, height]);

  const adFormat = calculateAdSize(width, height);

  return (
    <ins
      className={`adsbygoogle ${className || ''}`}
      style={{
        display: 'block',
        width: `100%`,
        height: `${height}px`,
      }}
      data-ad-format={adFormat === 'responsive' ? 'auto' : adFormat}
      data-full-width-responsive={adFormat === 'responsive' ? 'true' : undefined}
    ></ins>
  );
} 